import { useRef, useState } from 'react'
import { useTaskboard } from '../lib/taskboardContext.js'
import { objToken } from '../lib/format.js'
import useOutsideClose from '../lib/useOutsideClose.js'
import Avatar from './Avatar.jsx'
import { Bell } from '@phosphor-icons/react'

export default function NotificationsBell() {
  const { notifications, usersById, markNotificationRead, markAllNotificationsRead, openTaskInProject, openPeek } = useTaskboard()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  useOutsideClose(ref, open, () => setOpen(false))

  const unread = notifications.filter((n) => !n.read).length

  const onItem = (n) => {
    if (!n.read) markNotificationRead(n.id)
    if (n.taskId) openTaskInProject(n.projectId, n.taskId)
    else if (n.contactId) openPeek(objToken('contact', n.contactId))
    setOpen(false)
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen((v) => !v)}
        title="Notifications"
        style={{ position: 'relative', background: 'none', border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-sm)', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-muted)' }}
      >
        <Bell size={16} />
        {unread > 0 && (
          <span style={{ position: 'absolute', top: -5, right: -5, minWidth: 16, height: 16, padding: '0 4px', borderRadius: 8, background: 'var(--color-gold)', color: 'var(--color-bg-dark)', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-mono)' }}>
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </button>

      {open && (
        <div style={{ position: 'absolute', top: 42, right: 0, width: 320, maxHeight: 420, overflowY: 'auto', background: 'var(--color-panel-dark)', border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-md)', padding: 6, zIndex: 30, animation: 'pop .12s ease' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px 10px', borderBottom: '1px solid var(--color-divider-dark)', marginBottom: 6 }}>
            <span className="tag-label" style={{ color: 'var(--color-gold)' }}>Notifications</span>
            <div style={{ flex: 1 }} />
            {unread > 0 && (
              <button onClick={markAllNotificationsRead} style={{ background: 'none', border: 'none', color: 'var(--color-gold)', fontSize: 11, cursor: 'pointer', letterSpacing: '.02em' }}>
                Mark all read
              </button>
            )}
          </div>

          {notifications.length === 0 ? (
            <div style={{ fontSize: 13, color: 'var(--text-dim)', padding: '14px 8px' }}>You’re all caught up.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {notifications.map((n) => {
                const actor = usersById[n.actorUid]
                return (
                  <button
                    key={n.id}
                    onClick={() => onItem(n)}
                    style={{ display: 'flex', alignItems: 'flex-start', gap: 9, width: '100%', textAlign: 'left', background: n.read ? 'none' : 'rgba(200,168,75,.06)', border: 'none', borderRadius: 'var(--radius-sm)', padding: '9px 9px', cursor: 'pointer' }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--color-bg-dark)')}
                    onMouseLeave={(e) => (e.currentTarget.style.background = n.read ? 'none' : 'rgba(200,168,75,.06)')}
                  >
                    {actor ? <Avatar user={actor} size={24} /> : (
                      <span style={{ width: 24, height: 24, borderRadius: '50%', background: 'var(--color-bg-dark)', border: '1px solid var(--color-divider-dark)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, flexShrink: 0 }}>📨</span>
                    )}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12.5, color: 'var(--color-white)', lineHeight: 1.45 }}>{n.text}</div>
                      <div className="font-mono" style={{ fontSize: 10, color: 'var(--text-dim)', marginTop: 3, textTransform: 'uppercase', letterSpacing: '.04em' }}>
                        {{ mention: 'Mention', assignment: 'Assignment', 'form-submission': 'New lead' }[n.type] || n.type}
                      </div>
                    </div>
                    {!n.read && <span style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--color-gold)', flexShrink: 0, marginTop: 4 }} />}
                  </button>
                )
              })}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
